import React from 'react';
import Image from 'next/image';

import * as ContentWithCTA from '@/components/content-with-cta';
import { TrackedAnchor } from '@/components/ancher';

export interface ConversionAreaProps {
  title: string;
  text: string;
  image: string;
  button: string;
  link: string;
  index: number;
}

function ConversionArea({
  title,
  text,
  image,
  button,
  link,
  index,
}: ConversionAreaProps) {
  return (
    <div className="mx-auto flex w-[350px] max-w-[calc(100vw-2*36px)] flex-col 2xl:w-[640px]">
      <Image
        src={image}
        alt=""
        width={640}
        height={300}
        className="rounded-t-2xl"
        priority
      />
      <div className="rounded-b-2xl bg-3b-background-light p-8 text-center">
        <h3 className="mx-auto max-w-[20ch] text-h5 2xl:text-h4">{title}</h3>
        <div className="h-3" />
        <p className="mx-auto max-w-[25ch] text-sh2 font-medium text-3b-text-secondary 2xl:text-sh1">
          {text}
        </p>
        <div className="h-5" />
        <ContentWithCTA.ButtonWrapper>
          <ContentWithCTA.CTAButton variant="primary" asChild>
            <TrackedAnchor
              label={`conversion-area_${index + 1}`}
              position="main_cta"
              href={link}
              className="mx-auto"
              target="_blank"
            >
              {button}
            </TrackedAnchor>
          </ContentWithCTA.CTAButton>
        </ContentWithCTA.ButtonWrapper>
      </div>
    </div>
  );
}

export default ConversionArea;
